jQuery(document).ready(function ($) {

	var supportsVideo = !!document.createElement('video').canPlayType;

	if(supportsVideo){
		$('.video-player').each(function() {
			var video = $(this);
			var videoElement = $(this).get(0);

			var videoContainer = video.parent();
			var videoCover = videoContainer.find('.video-cover')

			videoCover.on('click',function() {
				$(this).hide()
				if (videoElement.paused || videoElement.ended) videoElement.play();
			})
		});

	}
});

document.addEventListener('DOMContentLoaded', function() {
    let videos = document.querySelectorAll('video');
    let links = document.querySelectorAll('a');
    links.forEach(function(link) {
        link.addEventListener('click', function() {
            videos.forEach(function(video) {
                video.pause()
                video.removeAttribute('src')
                video.load()
            })
        })
    })
})
